import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { BACKEND_API_URL } from "../../config";
import { toFileList } from "../utils";
// import { updateUserId } from "../FormNavigator/navigatorSlice";



export const fetchInitialState = createAsyncThunk(
  'MarketingData/fetch', 
  async (data, { getState, dispatch }) => {
    let unpreserved_state = {
        isDetails: '',
        companyBranchName: '',

        isWebsite: '',
        branchWebsite: '',
        
        isSocialMediaProfiles: '',
        branchLinkedIn: '',
        branchTwitterXProfile: '',
        branchFacebookProfile: '',
        branchInstagramProfile: '',
        branchZillowProfile: '',
        branchGoogleMyBusiness: '',

        isTeamPhoto: '',
        teamPhotos: [],

        branchPhotos: [],
        branchImages: [],
    };
    const token = getState().navigator.token
      try {
        const response = await fetch(`${BACKEND_API_URL}/api/onboarding/marketing_details?token=${token}`);
        if (!response.ok) {
          throw new Error('Failed to fetch initial state');
        }
        const initialState = await response.json();
        return initialState;
      } catch (error) {
        console.error('Error fetching initial state:', error);
        return unpreserved_state
      }
    
  })


const initialState = {
    data: {
        isDetails: '',
        companyBranchName: '',

        isWebsite: '',
        isDBA: '',
        branchWebsite: '',
        
        isSocialMediaProfiles: '',
        branchLinkedIn: '',
        branchTwitterXProfile: '',
        branchFacebookProfile: '',
        branchInstagramProfile: '',
        branchZillowProfile: '',
        branchGoogleMyBusiness: '',

        isTeamPhoto: '',
        teamPhotos: [],

        branchPhotos: [],
        branchImages: [],
    },
    status: 'idle', // 'idle' | 'loading' | 'success' | 'failed'
    loading: false,
    error: null,
    formErrors: {},
    // Set once Next fails validation, so the form can mark every unanswered
    // mandatory question inline instead of only showing one toast.
    submitAttempted: false,
}

/**
 * The Branch Photo is only asked for when the branch actually has a location — the
 * form shows the upload under the same condition, so both read this list.
 */
export const BRANCH_PHOTO_LOCATION_OPTIONS = [
    'Existing Location with Lease',
    'Existing Location without Lease',
];

export const SOCIAL_MEDIA_FIELD_NAMES = ['branchLinkedIn', 'branchTwitterXProfile', 'branchFacebookProfile', 'branchInstagramProfile', 'branchZillowProfile', 'branchGoogleMyBusiness'];

// At least one real profile entered. Older profiles can come back with null
// fields, so null / whitespace count as empty (the form uses this same check).
export const hasSocialMediaProfile = (data) =>
    SOCIAL_MEDIA_FIELD_NAMES.some((key) => typeof data?.[key] === 'string' && data[key].trim() !== '');

export const SubmitMarketingDetails = createAsyncThunk(
    'MarketingData/submit',
    async (data, { getState, dispatch, rejectWithValue }) => {

        // Create a copy of the data object to avoid direct state mutation
        let updatedData = { ...data };
        
        // Perform client-side validation or dispatch another action to set validation state
        const { data: stateData } = getState().marketing;

        // Team / Branch name is mandatory for every onboarding flow
        if (!data.companyBranchName || !data.companyBranchName.trim()) {
          return rejectWithValue("Please enter the team / branch name.");
        }
        updatedData.isDetails = 'Yes';

        // Validate isWebsite
        if (stateData.isWebsite !== 'Yes' && stateData.isWebsite !== 'No') {
          return rejectWithValue("Please select the option.");
        }
        // Check required fields based on isWebsite
        if (stateData.isWebsite === 'Yes') {
          if (!data.branchWebsite) {
            return rejectWithValue("Please fill the branch website.");
          }
          // Check if branchWebsite ends with .com or .biz
          const isValidWebsite = data.branchWebsite.endsWith('.com') || data.branchWebsite.endsWith('.biz');
          if (!isValidWebsite) {
              return rejectWithValue("Branch website must end with .com or .biz.");
          }
        } else {
          updatedData.branchWebsite = '';
        }

        // Validate isSocialMediaProfiles
        if (stateData.isSocialMediaProfiles !== 'Yes' && stateData.isSocialMediaProfiles !== 'No') {
          return rejectWithValue("Please select the option.");
        }
        // Check required fields based on isSocialMediaProfiles
        if (stateData.isSocialMediaProfiles === 'Yes') {
          if (!hasSocialMediaProfile(data)) {
            return rejectWithValue("Please fill the data in the required fields for social media profiles.");
          }
        } else {
          SOCIAL_MEDIA_FIELD_NAMES.forEach(key => updatedData[key] = '');
        }

        // Validate isSocialMediaProfiles
        if (stateData.isTeamPhoto !== 'Yes' && stateData.isTeamPhoto !== 'No') {
          return rejectWithValue("Please select the option for branch or team photos.");
        } 
        // Check required images based on isTeamPhoto
        if (stateData.isTeamPhoto === 'Yes') {
          // Empty slots come back as null / "null", so only real files count
          if (toFileList(data.teamPhotos).length === 0) {
            return rejectWithValue("Please upload branch or team photos.");
          }
        } else {
          updatedData.teamPhotos = [];
        }

        // The Branch Photo is required wherever the form asks for it
        const branchLocationOption = getState().branch_location?.data?._option;
        if (BRANCH_PHOTO_LOCATION_OPTIONS.includes(branchLocationOption) && toFileList(data.branchPhotos).length === 0) {
          return rejectWithValue("Please upload a branch photo to be displayed on Google my business.");
        }

        const currentStep = getState().navigator.currentStep;
        const token = getState().navigator.token;

        try {
            const response = await fetch(`${BACKEND_API_URL}/api/onboarding/marketing_details?token=${token}`, {
                method: 'POST',
                body: JSON.stringify({'data': updatedData, 'current_step': currentStep }),
                headers: {
                    'Content-Type': 'application/json',
                }
            });
  
            if (!response.ok) {
              const errors = await response.json();
              Object.entries(errors).forEach(([field, error]) => {
                dispatch(setFieldError({ field, error }));
              });
              return rejectWithValue(errors);
            }
  
            const response_data =  await response.json(); 
            return response_data;
          } catch (error) {
            console.error('Form submission error', error);
            return rejectWithValue(error);
          }

      }
)


export const UploadBranchImages = createAsyncThunk(
  'MarketingData/upload',
  async ({data, files, label}, { getState, dispatch, rejectWithValue }) => {
      const token = getState().navigator.token;

      // because of Images, send as FormData
      const formData = new FormData();

      // Use object destructuring to exclude branchImages and branchPhotos
      const { branchImages, branchPhotos, teamPhotos, ...restData } = data;

      for (let i = 0; i < files?.length; i++) {
          formData.append(`${label}[]`, files[i]);
      }

      Object.keys(restData).forEach((key) => {
          formData.append(key, restData[key]);
      });

      try {
          // Here you would send the form data to the server
          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/branch_images_upload?token=${token}`, {
              method: 'POST',
              body: formData
          });

          if (!response.ok) {
            // If the response is not 2xx, it is considered an error
            const errors = await response.json();
            // console.log(errors);
            return rejectWithValue(errors);
          }

          const response_data =  await response.json();
          // Handle the response data
          console.log('File uploaded successfully', response_data);
          return response_data;

        } catch (error) {
          // Handle submission errors
          console.error('File upload error', error);
          alert('File upload error');
          // Throw an error for the rejected action
          return rejectWithValue(error);
        }

    }
)


export const DeleteBranchImages = createAsyncThunk(
  'MarketingData/delete',
  async ({imageToDelete, label}, { getState, dispatch, rejectWithValue }) => {
      const token = getState().navigator.token;

      const requestData = {
        [label]: imageToDelete,
      };

      try {
          // Here you would send the form data to the server

          const response = await fetch(`${BACKEND_API_URL}/api/onboarding/branch_images_deletion?token=${token}`, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify(requestData),
          });

          if (!response.ok) {
            // If the response is not 2xx, it is considered an error
            const errors = await response.json();
            // console.log(errors);
            return rejectWithValue(errors);
          }

          const response_data =  await response.json();
          // Handle the response data
          console.log('File uploaded successfully', response_data);
          return response_data;

        } catch (error) {
          // Handle submission errors
          console.error('File upload error', error);
          alert('File upload error');
          // Throw an error for the rejected action
          return rejectWithValue(error);
        }

    }
)


export const marketingDetailsSlice = createSlice({
    name: 'MarketingDetails',
    initialState,
    reducers: {
      setFormField: (state, action) => {
        const { field, value } = action.payload;
        state.data[field] = value;
      },
      setFieldError: (state, action) => {
        const { field, error } = action.payload;
        state.formErrors[field] = error;
      },
      updateDetailsOption: (state, action) => {
        state.data.isDetails = action.payload;
      },
      updateWebsiteOption: (state, action) => {
        state.data.isWebsite = action.payload;
      },
      updateDBAOption: (state, action) => {
        state.data.isDBA = action.payload;
      },
      updateSocialMediaProfilesOption: (state, action) => {
        state.data.isSocialMediaProfiles = action.payload;
      },
      updateTeamPhotoOption: (state, action) => {
        state.data.isTeamPhoto = action.payload;
      },
    },
    extraReducers: (builder) => {
        builder
          .addCase(SubmitMarketingDetails.pending, (state) => {
            state.loading = true;
          })
          .addCase(SubmitMarketingDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.submitAttempted = false;
          })
          .addCase(SubmitMarketingDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
            // Only a failed client-side check (a message string) means answers are
            // missing — a server / network error says nothing about the form.
            if (typeof action.payload === 'string') state.submitAttempted = true;
          })
          .addCase(UploadBranchImages.pending, (state) => {
            state.loading = true;
          })
          .addCase(UploadBranchImages.fulfilled, (state, action) => {
            state.loading = false;
            state.data.branchImages = state.data.branchImages.concat(action.payload?.branchImages || [])
            state.data.branchPhotos = state.data.branchPhotos.concat(action.payload?.branchPhotos || [])
            state.data.teamPhotos = state.data.teamPhotos.concat(action.payload?.teamPhotos || [])
          })
          .addCase(UploadBranchImages.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
          .addCase(DeleteBranchImages.pending, (state) => {
            state.loading = true;
          })
          .addCase(DeleteBranchImages.fulfilled, (state, action) => {
            state.loading = false;
            // Check the label to determine whether to update branchImages or branchPhotos
            const { label, imageToDelete } = action.meta.arg;

            console.log(label, imageToDelete);

            if (label === 'branchImage') {
              state.data.branchImages = state.data.branchImages.filter(image => image !== imageToDelete);
            } else if (label === 'branchPhoto') {
              state.data.branchPhotos = state.data.branchPhotos.filter(photo => photo !== imageToDelete);
            } else if (label === 'teamPhoto') {
              state.data.teamPhotos = state.data.teamPhotos.filter(photo => photo !== imageToDelete);
            }
          })
          .addCase(DeleteBranchImages.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          })
          .addCase(fetchInitialState.pending, (state) => {
            state.loading = true;
          })
          .addCase(fetchInitialState.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            // Coming back to the step starts clean — no errors before a new Next.
            state.submitAttempted = false;
          })
          .addCase(fetchInitialState.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
          });
      },
  });


export const { setFormField, 
                setFieldError, 
                updateDetailsOption,
                updateDBAOption,
                updateWebsiteOption,
                updateSocialMediaProfilesOption,
                updateTeamPhotoOption } = marketingDetailsSlice.actions;

export default marketingDetailsSlice.reducer;
  